import Salad from '../assets/imgs/salad.png';
import fruitSalad from '../assets/imgs/fruit-salad.png'
import dessert from '../assets/imgs/dessert.png'
import soup from '../assets/imgs/soup.png'

export const related = [
    {id:1, imgs:`${Salad}`, tag:'Tag', title:'Space for your heding is here, write what you need', author:'Author', date:'15.6.2020' },
    {id:2, imgs:`${fruitSalad}`, tag:'Tag', title:'Space for your heding is here, write what you need', author:'Author', date:'15.6.2020' },
    {id:3, imgs:`${dessert}`, tag:'Tag', title:'Space for your heding is here, write what you need', author:'Author', date:'15.6.2020' },
    {id:4, imgs:`${soup}`, tag:'Tag', title:'Space for your heding is here, write what you need', author:'Author', date:'15.6.2020' },
]